import React from "react";

export const Whyjoin = () => {
  return (
    <div>
      {/* <section className="">
        <div className="">
         
          <div className="bg-[#1E1E1E] px-[50px] py-5">
<div className="flex justify-center gap-5 items-center">
  <div className="flex-1">
<h3 className="py-5 text-3xl text-[#12B1E0] font-bold"> TOP 3 REVENUE GENERATORS</h3>
<p className="py-5 text-lg font-thin">While there are multiple revenue opportuinties, the following
are anicipated to be the primary revenue sources</p>


  </div>
  <div className="flex-1">
<div className="flex gap-5 items-center">
  <img src={process.env.PUBLIC_URL +'/assets/a1.png'}/>
  <h3 className="text-3xl font-bold">Advertising</h3>
</div>
<div className="flex gap-5 items-center py-5">
  <img src={process.env.PUBLIC_URL +'/assets/a2.png'}/>
  <h3 className="text-3xl font-bold">Consulting</h3>
</div>
<div className="flex gap-5 items-center">
  <img src={process.env.PUBLIC_URL +'/assets/a3.png'}/>
  <h3 className="text-3xl font-bold">Membership</h3>
</div>


  </div>
</div>




          </div>
        </div>
      </section> */}
      <img src={process.env.PUBLIC_URL +'/assets/join.jpg'} className="w-full"/>
    </div>
  );
};
